var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4375 3.98438V0H2.57812C2.18848 0 1.875 0.313477 1.875 0.703125V14.2969C1.875 14.6865 2.18848 15 2.57812 15H12.4219C12.8115 15 13.125 14.6865 13.125 14.2969V4.6875H9.14062C8.75391 4.6875 8.4375 4.37109 8.4375 3.98438ZM10.3125 10.8984C10.3125 11.0918 10.1543 11.25 9.96094 11.25H5.03906C4.8457 11.25 4.6875 11.0918 4.6875 10.8984V10.6641C4.6875 10.4707 4.8457 10.3125 5.03906 10.3125H9.96094C10.1543 10.3125 10.3125 10.4707 10.3125 10.6641V10.8984ZM10.3125 9.02344C10.3125 9.2168 10.1543 9.375 9.96094 9.375H5.03906C4.8457 9.375 4.6875 9.2168 4.6875 9.02344V8.78906C4.6875 8.5957 4.8457 8.4375 5.03906 8.4375H9.96094C10.1543 8.4375 10.3125 8.5957 10.3125 8.78906V9.02344ZM10.3125 6.91406V7.14844C10.3125 7.3418 10.1543 7.5 9.96094 7.5H5.03906C4.8457 7.5 4.6875 7.3418 4.6875 7.14844V6.91406C4.6875 6.7207 4.8457 6.5625 5.03906 6.5625H9.96094C10.1543 6.5625 10.3125 6.7207 10.3125 6.91406ZM13.125 3.57129V3.75H9.375V0H9.55371C9.74121 0 9.91992 0.0732422 10.0518 0.205078L12.9199 3.07617C13.0518 3.20801 13.125 3.38672 13.125 3.57129Z",
    fill: "#808282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAlt);
export default __webpack_public_path__ + "static/media/FileAlt.de52fd9fd3fe471552823b9433116ab3.svg";
export { ForwardRef as ReactComponent };